/* eslint-disable */
import { useStore } from '../../core/useStore';

export default function getApiBusinessDocPath(api_name, version, solution_type, dataTestId) {
  const getCatalogdata = !dataTestId ? useStore.getState().defaultApiSideMenu : dataTestId;
  let api_path = '';
  getCatalogdata &&
    getCatalogdata.map((item) => {
      if (item?.name === solution_type) {
        let filteredJson = item?.subMenu.filter(
          (x) =>
            x.apiMachineName && x.apiMachineName === api_name && x.version && x.version === version,
        );

        api_path = filteredJson
          ? filteredJson[0]?.subMenu
            ? filteredJson[0]?.subMenu[0].path
            : filteredJson[0]?.path
          : '';
      }
    });
  return api_path;
}
